enum TaskStatusEnum {
    COMPLETED = "COMPLETED",
    ERROR = "ERROR",
    PENDING = "PENDING",
    RUNNING = "RUNNING",
}

export default TaskStatusEnum;
